/* SeraVita PDP rebuild — behaviour for the sv-pdp-* sections.
   No dependencies. Each feature binds to a data attribute so sections can be
   added, removed or reordered in the theme editor independently. */
(function () {
  'use strict';
  // Every sv-pdp section includes this file; only the first copy runs.
  if (window.__svPdpLoaded) return;
  window.__svPdpLoaded = true;

  /* ---------------------------------------------------------------- gallery */
  function initGallery(root) {
    if (root.__svp) return; root.__svp = true;
    var slides = root.querySelectorAll('.svp-gallery__slide');
    var thumbs = root.querySelectorAll('.svp-thumb');
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        s.classList.toggle('is-active', k === current);
        s.setAttribute('aria-hidden', String(k !== current));
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === current)); });
      root.querySelector('.svp-gallery__stage').classList.toggle('is-first', current === 0);
      if (thumbs[current] && thumbs[current].parentElement) {
        var strip = thumbs[current].parentElement, t = thumbs[current];
        if (t.offsetLeft < strip.scrollLeft || t.offsetLeft + t.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - 8, behavior: 'smooth' });
      }
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var strip = root.querySelector('.svp-thumbs');
    var more = root.querySelector('[data-svp-thumbs-next]');
    if (strip && more) {
      var sync = function () { more.hidden = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2; };
      more.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.8, behavior: 'smooth' }); });
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    root.querySelectorAll('[data-svp-gallery-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(current + Number(b.dataset.svpGalleryStep)); });
    });
    var stage = root.querySelector('.svp-gallery__stage');
    var startX = null;
    stage.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });
  }

  /* ---------------------------------------------------------------- buy box */
  // Bundles, gifts and subscriptions come from Kaching: it rewrites the
  // /cart/add request with the selected deal and updates the price shown in
  // the button. This only sends the request and opens the cart afterwards.
  function initBuyBox(root) {
    if (root.__svp) return; root.__svp = true;
    var form = root.querySelector('form');
    var button = form.querySelector('.svp-atc');
    var error = root.querySelector('.svp-atc__error');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      button.setAttribute('aria-busy', 'true');
      if (error) error.hidden = true;

      var data = new FormData(form);
      var themeDrawer = document.querySelector('cart-drawer');
      if (themeDrawer && typeof themeDrawer.getSectionsToRender === 'function') {
        data.append('sections', themeDrawer.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        data.append('sections_url', window.location.pathname);
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.json.description || res.json.message || 'Could not add to cart');
          document.dispatchEvent(new CustomEvent('sv:cart:added', { detail: res.json }));
          if (root.dataset.afterAdd === 'cart_page') { window.location.href = '/cart'; return; }
          if (themeDrawer && res.json.sections && Object.keys(res.json.sections).length && typeof themeDrawer.renderContents === 'function') {
            themeDrawer.renderContents(res.json);
            return;
          }
          // Cart apps such as Upcart watch /cart/add.js and open themselves.
          // Fall back to the cart page when none is on the page.
          var cartApp = document.querySelector('script[src*="upcart" i], [id^="upCart"], [class*="upcart" i]');
          if (!cartApp) window.location.href = '/cart';
        })
        .catch(function (err) {
          if (error) { error.textContent = err.message; error.hidden = false; }
        })
        .finally(function () { button.removeAttribute('aria-busy'); });
    });
  }

  /* ---------------------------------------------------------------- deal price */
  // The header and sticky prices show a Kaching bundle bar's own price and
  // strikethrough: the first bundle until the visitor picks one, then the
  // selected bundle.
  function initPriceSync(main) {
    if (main.__svpPrice) return; main.__svpPrice = true;
    var targets = main.querySelectorAll('[data-svp-price]');
    if (!targets.length) return;
    var followSelection = false;
    var BARS = 'kaching-bundle .kaching-bundles__bars:not(.kaching-bundles__subscriptions) > .kaching-bundles__bar';

    function reveal() { targets.forEach(function (t) { t.classList.remove('svp-price--pending'); }); }

    function sync() {
      var buyOnce = main.querySelector('[data-svp-buyonce]');
      if (buyOnce && buyOnce.__buying) return;
      var bars = Array.prototype.slice.call(main.querySelectorAll(BARS));
      if (!bars.length) return;  // Kaching not rendered yet
      var selected = followSelection
        ? bars.filter(function (b) { return b.classList.contains('kaching-bundles__bar--selected'); })[0] || bars[0]
        : bars[0];
      function prices(bar) {
        var priceEl = bar.querySelector('.kaching-bundles__bar-price');
        var fullEl = bar.querySelector('.kaching-bundles__bar-full-price');
        return { price: priceEl ? priceEl.textContent.trim() : '', compare: fullEl ? fullEl.textContent.trim() : '' };
      }
      var dynamic = prices(selected);
      var first = prices(bars[0]);  // data-svp-price-fixed (sticky bar) always shows the first bundle
      if (!dynamic.price) return;
      targets.forEach(function (t) {
        var p = t.hasAttribute('data-svp-price-fixed') ? first : dynamic;
        var price = p.price, compare = p.compare;
        var cur = t.querySelector('[data-svp-price-current]');
        var cmp = t.querySelector('[data-svp-price-compare]');
        if (cur && cur.textContent !== price) cur.textContent = price;
        if (cmp) {
          if (cmp.textContent !== compare) cmp.textContent = compare;
          cmp.hidden = !compare || compare === price;
        }
      });
      reveal();
    }

    main.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest(BARS)) return;
      followSelection = true;
      setTimeout(sync, 50);  // let Kaching mark the new selection first
    });
    new MutationObserver(sync).observe(main.querySelector('.svp-buy') || main, { subtree: true, childList: true, characterData: true });
    setTimeout(reveal, 3000);  // if Kaching never loads, show the product's own price
    sync();
  }

  /* ---------------------------------------------------------------- buy once */
  // Keeps Kaching's (hidden) subscription option switched on, and offers the
  // selected bundle as a one-time purchase. The one-time price is the deal's
  // own price from Kaching's settings; nothing is priced here.
  function initBuyOnce(root) {
    var wrap = root.querySelector('[data-svp-buyonce]');
    if (!wrap || wrap.__svp) return; wrap.__svp = true;
    var link = wrap.querySelector('button');
    var priceEl = wrap.querySelector('[data-svp-buyonce-price]');
    var atc = root.querySelector('.svp-atc');

    function block() { return root.querySelector('kaching-bundle'); }
    function toggle() { var b = block(); return b && b.querySelector('.kaching-bundles__subscriptions [role="checkbox"]'); }
    function isOn() { var t = toggle(); return !!t && t.getAttribute('aria-checked') === 'true'; }
    function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

    function dealBars() {
      var b = block();
      var id = b && b.getAttribute('product-id');
      var script = id && document.querySelector('script.kaching-bundles-deal-block-settings[data-product-id="' + id + '"]');
      try { return script ? JSON.parse(script.textContent).dealBars || [] : []; } catch (e) { return []; }
    }

    function format(amount) {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(amount); }
      catch (e) { return '$' + amount.toFixed(2); }
    }

    function update() {
      var b = block();
      var t = toggle();
      if (!b || !t) return;
      if (!isOn() && !wrap.__buying) t.click();
      var bars = Array.prototype.slice.call(b.querySelectorAll('.kaching-bundles__bars:not(.kaching-bundles__subscriptions) > .kaching-bundles__bar'));
      var index = bars.findIndex(function (el) { return el.classList.contains('kaching-bundles__bar--selected'); });
      var bar = dealBars()[index];
      if (!bar || bar.discountType !== 'specific') { wrap.hidden = true; return; }
      var text = format(Number(bar.discountValue));
      if (priceEl.textContent !== text) priceEl.textContent = text;  // avoid re-triggering the observer
      if (wrap.hidden) wrap.hidden = false;
    }

    link.addEventListener('click', function () {
      var t = toggle();
      if (!t || wrap.__buying) return;
      wrap.__buying = true;
      link.setAttribute('aria-busy', 'true');
      // Kaching builds and sends its cart request within a few ms of the
      // button click, so the subscription can be switched back on shortly after.
      if (isOn()) t.click();
      wait(350)
        .then(function () { atc.click(); return wait(1200); })
        .then(function () {
          if (!isOn()) t.click();
          wrap.__buying = false;
          link.removeAttribute('aria-busy');
        });
    });

    // Kaching renders after load and re-renders on every selection.
    new MutationObserver(function () { if (!wrap.__buying) update(); })
      .observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'aria-checked'] });
    update();
  }

  /* ---------------------------------------------------------------- smooth scroll */
  // "Claim offer" and the sticky "Shop now" link to #shop; glide there instead
  // of jumping, clearing the theme's sticky header if it has one.
  function stickyHeaderHeight() {
    var el = document.querySelector('sticky-header, .shopify-section-header-sticky, .section-header');
    if (!el) return 0;
    var pos = getComputedStyle(el).position;
    return pos === 'sticky' || pos === 'fixed' ? el.getBoundingClientRect().height : 0;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.svp a[href^="#"]');
    if (!link || link.getAttribute('href').length < 2) return;
    var target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    e.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - 12;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
  });

  /* ---------------------------------------------------------------- shipping country */
  // Shows the visitor's country, detected by Shopify itself, in the shipping line.
  function initCountry(el) {
    if (el.__svp) return; el.__svp = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!code || !/^[A-Z]{2}$/.test(code)) return;
        var flag = el.querySelector('[data-svp-country-flag]');
        var label = el.querySelector('[data-svp-country-code]');
        if (flag) flag.src = 'https://flagcdn.com/w40/' + code.toLowerCase() + '.png';
        if (label) label.textContent = code;
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------------- sticky bar */
  // Shown once the main add-to-cart button has scrolled out of view above.
  function initSticky(bar) {
    if (bar.__svp) return; bar.__svp = true;
    var scope = bar.closest('.svp-main') || document;
    var target = scope.querySelector('.svp-atc');
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
    }).observe(target);
  }

  /* ---------------------------------------------------------------- countdown */
  function initCountdown(el) {
    if (el.__svp) return; el.__svp = true;
    var fixed = el.dataset.end ? new Date(el.dataset.end) : null;
    function tick() {
      var now = new Date();
      var end = fixed;
      if (!end || isNaN(end) || end <= now) {
        end = new Date(now); end.setHours(24, 0, 0, 0);
      }
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var pad = function (n) { return String(n).padStart(2, '0'); };
      el.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---------------------------------------------------------------- reviews */
  function initReview(card) {
    if (card.__svp) return; card.__svp = true;
    var quote = card.querySelector('.svp-review__quote');
    var btn = card.querySelector('.svp-review__more');
    if (!quote || !btn) return;
    requestAnimationFrame(function () {
      if (quote.scrollHeight <= quote.clientHeight + 2) { btn.hidden = true; return; }
      btn.addEventListener('click', function () {
        var open = quote.classList.toggle('is-clamped') === false;
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  /* ---------------------------------------------------------------- carousel */
  function initCarousel(root) {
    if (root.__svp) return; root.__svp = true;
    var track = root.querySelector('.svp-track, .svp-review-grid');
    var prev = root.querySelector('[data-svp-prev]');
    var next = root.querySelector('[data-svp-next]');
    var dots = root.querySelector('.svp-dots');
    if (!track) return;
    function step() {
      var c = track.children[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return c ? c.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function pages() { return Math.max(1, Math.round((track.scrollWidth - track.clientWidth) / step()) + 1); }
    function render() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max - 2;
      var n = pages();
      var nav = root.querySelector('.svp-carousel-nav');
      if (nav) nav.hidden = n <= 1;
      if (!dots) return;
      if (dots.children.length !== n) dots.innerHTML = new Array(n + 1).join('<span></span>');
      var active = Math.round(track.scrollLeft / step());
      Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-active', i === active); });
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(render); }, { passive: true });
    window.addEventListener('resize', render);
    render();
  }

  /* ---------------------------------------------------------------- accordions */
  // Keep one item open per group (browsers without <details name> support).
  function initAccordion(root) {
    if (root.__svp) return; root.__svp = true;
    root.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d.open) return;
      root.querySelectorAll('details[open]').forEach(function (o) { if (o !== d) o.open = false; });
    }, true);
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-svp-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-svp-buy]').forEach(initBuyBox);
    scope.querySelectorAll('[data-svp-buy]').forEach(initBuyOnce);
    scope.querySelectorAll('[data-svp-sticky]').forEach(initSticky);
    scope.querySelectorAll('[data-svp-country]').forEach(initCountry);
    scope.querySelectorAll('.svp-main').forEach(initPriceSync);
    scope.querySelectorAll('[data-svp-countdown]').forEach(initCountdown);
    scope.querySelectorAll('.svp-review').forEach(initReview);
    scope.querySelectorAll('[data-svp-carousel]').forEach(initCarousel);
    scope.querySelectorAll('[data-svp-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  // Theme editor: re-bind when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
